"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renameCallStack = renameCallStack;
exports.namedCallStack = namedCallStack;
function renameCallStack(error, name, message, removeStackLines = 0) {
    if (!error.stack) {
        return undefined;
    }
    return error.stack
        .toString()
        .replace(/^Error/, message ? `${name}: ${message}` : `${name}:`)
        .replace(new RegExp(`(\\n\\s+at .*){${removeStackLines + 1}}`), '');
}
function namedCallStack(name, message, removeStackLines = 0) {
    return renameCallStack(new Error(), name, message, removeStackLines);
}
//# sourceMappingURL=namedCallStack.js.map